/**
 * TodayContext: the page-injected "today" (the practice's calendar day,
 * 'YYYY-MM-DD'), extending the Overview tab's injected-today prop to the
 * deep provenance surfaces (ProvenanceChip, VitalsBand, NotesFeed) without
 * threading a prop through every card variant.
 *
 * The PAGE computes the value once at its boundary
 * (practiceTodayIso(), see ClientRecord.tsx; stamps resolve to their day
 * with practiceDayOfStamp, src/lib/practiceDate.ts, on the same clock) and
 * provides it here; components only ever CONSUME it — never Date.now() —
 * so "today"/"yesterday" phrasing stays deterministic under test. Tests
 * provide a fixed day (or provide nothing: an absent value renders every
 * prose date absolute — the safe fallback, never a wrong relative word).
 */

import { createContext, useContext } from 'react';

export const TodayContext = createContext<string | undefined>(undefined);

/** The injected practice day ('YYYY-MM-DD'), or undefined outside a provider
 *  (callers fall back to absolute prose dates). */
export function useToday(): string | undefined {
  return useContext(TodayContext);
}
